import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import * as LoyaltyProgramService from '../../../../../../../api/services/loyaltyProgramService';
import { Column, Grid } from '../../../../../../../components/Layout/Main';
import EditPrizeDrawCampaignForm from './EditPrizeDrawCampaignForm';
import * as StampCampaignService from '../../../../../../../api/services/stampCampaignService';

//------------------------------------------------------------------------------
// Styles
//------------------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(4),
  },
}));

//------------------------------------------------------------------------------
// Types
//------------------------------------------------------------------------------

interface RouteParams {
  id: string;
  campaignId: string;
}

//------------------------------------------------------------------------------
// Screen
//------------------------------------------------------------------------------

const EditPrizeDrawCampaign = () => {
  const classes = useStyles();
  const { id: merchantId, campaignId } = useParams<RouteParams>();

  const [redirectTo, setRedirectTo] = useState('');
  const [program, setProgram] = useState<
    LoyaltyProgramService.LoyaltyProgram | undefined
  >(undefined);
  const [campaign, setCampaign] = useState<
    StampCampaignService.StampCampaign | undefined
  >(undefined);

  // Fetch the program
  useEffect(() => {
    let isMounted = true;

    const fetch = async () => {
      try {
        const res = await LoyaltyProgramService.getByMerchant(merchantId);

        if (isMounted) {
          setProgram(res);
        }
      } catch (e) {
        console.log(e);
      }
    };

    fetch();

    return () => {
      isMounted = false;
    };
  }, [merchantId]);

  // Fetch stamp campaign
  useEffect(() => {
    const fetchStampCampaign = async () => {
      try {
        if (campaignId) {
          console.log('Program Id', campaignId);
          const res = await StampCampaignService.get(campaignId);

          setCampaign(res);
        }
      } catch (e) {
        console.log(e);
      }
    };

    fetchStampCampaign();
  }, [campaignId]);

  if (redirectTo !== '') {
    return <Redirect to={redirectTo} />;
  }

  if (!program) {
    return null;
  }

  if (!campaign) {
    return null;
  }

  console.log('Program', program);

  return (
    <Grid>
      <Column xs={12}>
        <Paper className={classes.paper}>
          <Typography
            gutterBottom
            align="center"
            variant="h6"
            className={classes.title}
          >
            Edit Prize-Draw Stamp Campaign
          </Typography>

          <EditPrizeDrawCampaignForm
            onSubmit={async (values) => {
              try {
                await StampCampaignService.updatePrizeDraw({
                  details: values.minSpend,
                  maxStamps: values.totalStamps,
                  programId: program.id,
                  description: values.description,
                  notification: values.notification,
                  multipleCards: values.multipleEntries,
                  campaignId: campaign.id,
                  reissuedWelcomeRewards: values.resendWelcomeReward,
                  storeStampLimit: values.maxStampsPerStore,
                });
                setRedirectTo(`/merchants/${merchantId}/loyalty/`);
              } catch {
                alert('There was an error submitting this form');
              }
            }}
            campaign={campaign}
          />
        </Paper>
      </Column>
    </Grid>
  );
};

export default EditPrizeDrawCampaign;
